import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import {
  type ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "../ui/chart";
import type { WeekTotals } from "./metrics";

const slaConfig = {
  met: { label: "Met", color: "var(--chart-2)" },
  breached: { label: "Breached", color: "var(--chart-3)" },
} satisfies ChartConfig;

export function SlaChart({ totals }: { totals: WeekTotals[] }) {
  const data = totals.map((week) => ({
    week: week.week,
    met: week.slaMet,
    breached: week.slaBreached,
  }));
  return (
    <Card>
      <CardHeader>
        <CardTitle>SLA compliance</CardTitle>
        <CardDescription>Issues completed within their SLA vs breached, per week</CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer config={slaConfig} className="aspect-auto h-64 w-full">
          <BarChart data={data} margin={{ left: -20, right: 4 }}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="week" tickLine={false} axisLine={false} tickMargin={8} />
            <YAxis allowDecimals={false} tickLine={false} axisLine={false} width={40} />
            <ChartTooltip content={<ChartTooltipContent />} />
            <ChartLegend content={<ChartLegendContent />} />
            <Bar dataKey="met" stackId="sla" fill="var(--color-met)" />
            <Bar dataKey="breached" stackId="sla" fill="var(--color-breached)" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
